import React, { memo, useCallback, useMemo } from 'react'

import {HiOutlineArrowNarrowRight} from "react-icons/hi"
import {CgArrowsExchange} from "react-icons/cg"
import useReligionTaxContext from '../../../Hooks/ContextHooks/Main/useReligionTaxContext';


const exchangeRate = 86.55;

function ReligionTable() {

  const { religionItems = [], setReligionItems } = useReligionTaxContext()

  const { totalAf, totalUsd, formattedAmount } = useMemo(() => calculateTotals(religionItems),[religionItems]);

  const handleRemoveItem = useCallback((item) => {
    setReligionItems((prevItems) =>
      prevItems.filter((prevItem) => prevItem.for !== item.for)
    );
  }, [setReligionItems]);

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">For</th>
            <th scope="col">Type</th>
            <th scope="col">Count</th>
            <th scope="col">Amount( ؋ )</th>
            <th scope="col">Amount( $ )</th>
            <th scope="col">Owner</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {religionItems?.length > 0 ? religionItems?.map((item,i)=>{
            return (
              <tr key={i}>
              <td>{i+1}</td>
              <td>{item.for}</td>
              <td>{item.type}</td>
              <td>{item.count}</td>
              <td>{(item.count * item.amount )}</td>
              <td> <CgArrowsExchange className='text-warning'/> {((item.count * item.amount ) / exchangeRate).toLocaleString(undefined,{minimumFractionDigits:0, maximumSignificantDigits:4})}</td>
              <td>{item.owner}</td>
              <td><button type="button" className='btn btn-sm border-0 bg-transparent' onClick={()=>handleRemoveItem(item)}><i className='fa fa-times text-danger'></i></button></td>
            </tr>
            )
          }):<tr><td className='text-center' colSpan={8}>No tax!</td></tr>}
          <tr>
            <td colSpan={8}>
              <div className='d-flex flex-wrap mt-2'>
                <p className='fw-light link-title'>Exchange Rate:</p>
                <div className='flex-fill text-end'>
                   $1 <CgArrowsExchange className='fs-4'/> {exchangeRate} ؋
                </div>
              </div>
              <div className='d-flex flex-wrap'>
                <p className='fw-light link-title'>Total in Dolor:</p>
                <div className='flex-fill text-end'>
                   ${totalUsd.toLocaleString(undefined,{minimumFractionDigits:0, maximumFractionDigits:3})}
                </div>
              </div>
              <div className='d-flex flex-wrap'>
                <p className='fw-light link-title'>Total in Afghani:</p>
                <div className='flex-fill text-end' dir='rtl'>
                    {totalAf} ؋
                </div>
              </div>
              <div className='d-flex flex-wrap'>
                <p className='fw-light link-title'>Afghani <HiOutlineArrowNarrowRight /> USD:</p>
                <div className='flex-fill text-end'>
                  $  {formattedAmount}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default memo(ReligionTable)

function calculateTotals(religionItems) {

  const totalAf = religionItems.reduce((acc, item) => acc + item.amount * item.count,0);

  const totalUsd = totalAf / exchangeRate;

  const formattedAmount = (totalAf / exchangeRate).toFixed(3);

  return { totalAf, totalUsd, formattedAmount };

}